import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import { useState } from 'react';
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

function Help() {

    const [openParent, setOpenParent] = useState(null);

    const [openChild, setOpenChild] = useState(null);

    const segments = [
        {
            title: "Full Stack Web",
            items: [
                { name: "Front-End", tech: ["React", "Angular"] },
                { name: "Back-End", tech: ["Node", "DotNet", "Java", "Python"] },
                { name: "Database", tech: ["MongoDB", "MSSQL"] }

            ]
        },
        {
            title: "Full Stack Mobile",
            items: [
                { name: "Front-End", tech: ["Flutter"] },
                { name: "Back-End", tech: ["Node", "DotNet", "Java", "Python"] },
                { name: "Database", tech: ["MongoDB", "MSSQL"] },
            ]
        },
        {
            title: "Data",
            items: [
                { name: "Data Science", tech: ["Python", "Pandas"] },
                { name: "Data Analytics", tech: ["Power BI", "Python", "SQL", " Machine Learning Basics"] },
                { name: "Machine Learning", tech: ["TensorFlow", "Scikit-learn"] }
            ]
        },
        { title: "Digital Marketing", items: [] },
    ];

    return (
        <div className="n1 py-5">
            <h3 className="text-center n3">Our Programs</h3>

            <Row>
                <Col md={6}>
                    <Container className='n4'>

                        <div className="program-list n3">
                            {segments.map((seg, pIndex) => (
                                <div key={pIndex} className="program-block">
                                    {/* Parent */}
                                    <div
                                        className="program-parent"
                                        onClick={() => setOpenParent(openParent === pIndex ? null : pIndex)}
                                    >
                                        {seg.title}
                                        {seg.items.length > 0 && (
                                            openParent === pIndex
                                                ? <FaChevronDown />
                                                : <FaChevronRight />
                                        )}
                                    </div>

                                    {/* Children */}
                                    {openParent === pIndex && seg.items.length > 0 && (
                                        <div className="program-children">
                                            {seg.items.map((child, cIndex) => (
                                                <div key={cIndex}>
                                                    <div
                                                        className="program-child"
                                                        onClick={() =>
                                                            setOpenChild(openChild === `${pIndex}-${cIndex}` ? null : `${pIndex}-${cIndex}`)
                                                        }
                                                    >
                                                        {child.name}
                                                        {child.tech?.length > 0 && (
                                                            openChild === `${pIndex}-${cIndex}`
                                                                ? <FaChevronDown size={12} />
                                                                : <FaChevronRight size={12} />
                                                        )}
                                                    </div>

                                                    {/* Sub-children */}
                                                    {openChild === `${pIndex}-${cIndex}` && child.tech?.length > 0 && (
                                                        <ul className="program-subchild">
                                                            {child.tech.map((tech, tIndex) => (
                                                                <li key={tIndex}>{tech}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </Container>
                </Col>
                <Col md={6}>
                    <div className='n4'>
                        <h1 className='n3'>Let's help you navigate your next</h1>
                        <br />
                        <a href='https://wa.me/918667641134?text=Hii..' target='_blank'>
                            <button className='n5'>Contact us</button>
                        </a>
                    </div>
                </Col>

            </Row>

        </div>
    );
}

export default Help;
